import * as WtsAreas from './catalogs/areas';
import * as WtsCoursesAreas from './catalogs/coursesAreas';
import * as WtsCoursesStatus from './catalogs/coursesStatus';
import * as WtsPositions from './catalogs/positions';
import * as WtsProfiles from './catalogs/profiles';
import * as WtsSkills from './catalogs/skills';
import * as wtsDealer from './catalogs/dealer';
import * as wtsAgencies from './catalogs/agencies';
import * as wtsEmployees from './catalogs/employees';
import * as WtsCourses from './courses/courses';
import * as wtsAgendas from './courses/courseAgenda';
import * as wtsAgendaDealers from './courses/courseAgendaDealer';
import * as wtsAuth from './catalogs/wtsAuth';
import * as wtsEmailNotify from './catalogs/wtsEmailNotify';
import * as wtsParams from './catalogs/paramsWts';
import * as wtsCourseDocument from './catalogs/courseDocument';
import * as EmployeeCert from './employee/employeeCert';
import * as EmployeeMatricula from './employee/employeeMatricula';
import * as RegistroAgencias from './registroAgencias/registroAgencias';
import * as Certificacion from './catalogs/Certificacion';
import * as EmployeeNotify from './employee/employeeNotify';

const Reducers = {
  ...WtsAreas,
  ...WtsCoursesAreas,
  ...WtsCoursesStatus,
  ...WtsPositions,
  ...WtsProfiles,
  ...WtsSkills,
  ...wtsDealer,
  ...wtsAgencies,
  ...wtsEmployees,
  ...WtsCourses,
  ...wtsAgendas,
  ...wtsAgendaDealers,
  ...wtsAuth,
  ...wtsEmailNotify,
  ...wtsParams,
  ...wtsCourseDocument,
  ...EmployeeCert,
  ...EmployeeMatricula,
  ...RegistroAgencias,
  ...Certificacion,
  ...EmployeeNotify,
};

export default Reducers;
